import KeyValueTextElement from "../common/KeyValueTextElementComponent";
import ChargePointStrategyAccordionElementComponent from "./chargePointStrategy/ChargePointStrategyAccordionElementComponent";

export const ChargePointChargingPriceElementComponent = ({ chargePoint }) => {
  const { externalApi_ChargePointDetailsDTO } = chargePoint;

  const getChargingPriceElement = () => {
    if (!externalApi_ChargePointDetailsDTO.chargingStrategy) return getDefaultChargingCostsElement();
    else return getChargingStrategyCostsElement();
  };

  const getDefaultChargingCostsElement = () => {
    return (
      <>
        <KeyValueTextElement keyLabel="תעריף חשמל" valueText={`${externalApi_ChargePointDetailsDTO.defaultKWHPrice}₪`} />
        <label>המחיר לא כולל מע"מ</label>
      </>
    );
  };

  const getChargingStrategyCostsElement = () => {
    const { chargingStrategy } = externalApi_ChargePointDetailsDTO;
    return <ChargePointStrategyAccordionElementComponent chargingStrategy={chargingStrategy} />;
  };

  return <div>{getChargingPriceElement()}</div>;
};

export default ChargePointChargingPriceElementComponent;
